<template>
  <div
    v-if="this.errosGerais.Message"
    class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
  >
    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
      <inline-svg src="media/icons/duotune/general/gen044.svg" />
    </span>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-bold">
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
        <div class="fs-6 text-gray-600">
          {{ this.errosGerais.Message }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.errosValidacaoGeral.length && !this.loading"
    class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
  >
    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
      <inline-svg src="media/icons/duotune/general/gen044.svg" />
    </span>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-bold">
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
        <div class="fs-6 text-gray-600">
          <ul>
            <li v-for="value in this.errosValidacaoGeral" :key="value">
              {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column flex-lg-row">
    <div class="d-flex flex-column mb-7 me-lg-8 min-w-lg-300px min-w-xl-375px">
      <div class="card card-flush py-5">
        <div class="card-header">
          <h3 class="card-title">
            <img
              src="media/icons/duotune/coding/cod001.svg"
              class="me-2"
            />Configurações
          </h3>
        </div>
        <div class="card-body pt-0">
          <div
            id="menuConfiguracoes"
            class="menu menu-rounded menu-column menu-title-gray-700 menu-icon-gray-400 menu-arrow-gray-400 menu-bullet-gray-400 menu-arrow-gray-400 menu-state-bg fw-semibold"
            data-kt-menu="true"
          >
            <div class="menu-item">
              <a
                id="mPrincipal"
                @click="this.menuClick('mPrincipal')"
                :class="[this.idMenuSelecionado === 'mPrincipal' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/general/gen001.svg" />
                  </span>
                </span>
                <span class="menu-title">Principal</span>
              </a>
            </div>
            <div class="menu-item">
              <a
                id="mClientes"
                @click="this.menuClick('mClientes')"
                :class="[this.idMenuSelecionado === 'mClientes' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/communication/com014.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Clientes</span>
              </a>
            </div>
            <div class="menu-item">
              <a
                id="mEstoque"
                @click="this.menuClick('mEstoque')"
                :class="[this.idMenuSelecionado === 'mEstoque' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/ecommerce/ecm009.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Estoque</span>
              </a>
            </div>
            <div class="menu-item">
              <a
                id="mCertificadoDigital"
                @click="this.menuClick('mCertificadoDigital')"
                :class="[
                  this.idMenuSelecionado === 'mCertificadoDigital' && 'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/general/gen048.svg" />
                  </span>
                </span>
                <span class="menu-title">Certificado Digital</span>
              </a>
            </div>
            <div
              class="menu-item menu-link-indention menu-accordion"
              data-kt-menu-trigger="click"
            >
              <a class="menu-link py-3 border-3 border-start border-info">
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/general/gen005.svg" />
                  </span>
                </span>
                <span class="menu-title">Faturamento</span>
                <span class="menu-arrow"></span>
              </a>
              <div class="menu-sub menu-sub-accordion pt-3">
                <div class="menu-item">
                  <a
                    id="mFaturamentoGeral"
                    @click="this.menuClick('mFaturamentoGeral')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoGeral' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Geral</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoSituacaoTributaria"
                    @click="this.menuClick('mFaturamentoSituacaoTributaria')"
                    :class="[
                      this.idMenuSelecionado ===
                        'mFaturamentoSituacaoTributaria' && 'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Situação tributária</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoObservacoes"
                    @click="this.menuClick('mFaturamentoObservacoes')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoObservacoes' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Observações</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoBaseICMS"
                    @click="this.menuClick('mFaturamentoBaseICMS')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoBaseICMS' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Formula ICMS</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoIcmsSubstituicao"
                    @click="this.menuClick('mFaturamentoIcmsSubstituicao')"
                    :class="[
                      this.idMenuSelecionado ===
                        'mFaturamentoIcmsSubstituicao' && 'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Formula ICMS Substituição</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoIPI"
                    @click="this.menuClick('mFaturamentoIPI')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoIPI' && 'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Formula IPI</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoPISCOFINS"
                    @click="this.menuClick('mFaturamentoPISCOFINS')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoPISCOFINS' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Formula PIS/COFINS</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoModelos"
                    @click="this.menuClick('mFaturamentoModelos')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoModelos' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Modelos</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mFaturamentoRelacaoCFOP"
                    @click="this.menuClick('mFaturamentoRelacaoCFOP')"
                    :class="[
                      this.idMenuSelecionado === 'mFaturamentoRelacaoCFOP' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Relação CFOP</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="menu-item">
              <a
                id="mNFe"
                @click="this.menuClick('mNFe')"
                :class="[this.idMenuSelecionado === 'mNFe' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/abstract/abs007.svg" />
                  </span>
                </span>
                <span class="menu-title">Nota Fiscal Eletrônica</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mCompras"
                @click="this.menuClick('mCompras')"
                :class="[this.idMenuSelecionado === 'mCompras' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/ecommerce/ecm005.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Compras</span>
              </a>
            </div>
            <div
              class="menu-item menu-link-indention menu-accordion"
              data-kt-menu-trigger="click"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a class="menu-link py-3 border-3 border-start border-info">
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/ecommerce/ecm002.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Pedido de Venda</span>
                <span class="menu-arrow"></span>
              </a>
              <div class="menu-sub menu-sub-accordion pt-3">
                <div class="menu-item">
                  <a
                    id="mPedidoVendaConfiguracoes"
                    @click="this.menuClick('mPedidoVendaConfiguracoes')"
                    :class="[
                      this.idMenuSelecionado === 'mPedidoVendaConfiguracoes' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Configurações</span>
                  </a>
                </div>
                <div class="menu-item">
                  <a
                    id="mPedidoVendaImpressao"
                    @click="this.menuClick('mPedidoVendaImpressao')"
                    :class="[
                      this.idMenuSelecionado === 'mPedidoVendaImpressao' &&
                        'active',
                    ]"
                    class="menu-link py-3"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Impressão</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mFinanceiro"
                @click="this.menuClick('mFinanceiro')"
                :class="[this.idMenuSelecionado === 'mFinanceiro' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/finance/fin010.svg" />
                  </span>
                </span>
                <span class="menu-title">Financeiro</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mOrdemServico"
                @click="this.menuClick('mOrdemServico')"
                :class="[
                  this.idMenuSelecionado === 'mOrdemServico' && 'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/coding/cod009.svg" />
                  </span>
                </span>
                <span class="menu-title">Ordem de Serviço</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mEtiqueta"
                @click="this.menuClick('mEtiqueta')"
                :class="[this.idMenuSelecionado === 'mEtiqueta' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/ecommerce/ecm010.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Etiqueta</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mBoletos"
                @click="this.menuClick('mBoletos')"
                :class="[this.idMenuSelecionado === 'mBoletos' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/coding/cod002.svg" />
                  </span>
                </span>
                <span class="menu-title">Boletos</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 2"
            >
              <a
                id="mIndustria"
                @click="this.menuClick('mIndustria')"
                :class="[this.idMenuSelecionado === 'mIndustria' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/technology/teh005.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Indústria</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mPlanoContaCentroCusto"
                @click="this.menuClick('mPlanoContaCentroCusto')"
                :class="[
                  this.idMenuSelecionado === 'mPlanoContaCentroCusto' &&
                    'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/files/fil002.svg" />
                  </span>
                </span>
                <span class="menu-title">Plano de Conta / Centro de Custo</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mSuporte"
                @click="this.menuClick('mSuporte')"
                :class="[this.idMenuSelecionado === 'mSuporte' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/communication/com007.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Suporte</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mOutrosCadastros"
                @click="this.menuClick('mOutrosCadastros')"
                :class="[
                  this.idMenuSelecionado === 'mOutrosCadastros' && 'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/general/gen062.svg" />
                  </span>
                </span>
                <span class="menu-title">Outros Cadastros</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mPedidoCompra"
                @click="this.menuClick('mPedidoCompra')"
                :class="[
                  this.idMenuSelecionado === 'mPedidoCompra' && 'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/ecommerce/ecm008.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Pedido de Compra</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mMovimentacaoBancaria"
                @click="this.menuClick('mMovimentacaoBancaria')"
                :class="[
                  this.idMenuSelecionado === 'mMovimentacaoBancaria' &&
                    'active',
                ]"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/finance/fin001.svg" />
                  </span>
                </span>
                <span class="menu-title">Movimentação Bancária</span>
              </a>
            </div>
            <div
              class="menu-item"
              v-if="this.user.User.Emitente.tipo_pacote > 1"
            >
              <a
                id="mLojaVirtual"
                @click="this.menuClick('mLojaVirtual')"
                :class="[this.idMenuSelecionado === 'mLojaVirtual' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg
                      src="media/icons/duotune/electronics/elc004.svg"
                    />
                  </span>
                </span>
                <span class="menu-title">Loja Virtual</span>
              </a>
            </div>
            <div class="menu-item">
              <a
                id="mGenerator"
                @click="this.menuClick('mGenerator')"
                :class="[this.idMenuSelecionado === 'mGenerator' && 'active']"
                class="menu-link py-3 border-3 border-start border-info"
              >
                <span class="menu-icon">
                  <span class="svg-icon svg-icon-2 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/abstract/abs026.svg" />
                  </span>
                </span>
                <span class="menu-title">Generator</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-row-fluid mb-7 min-w-lg-375px">
      <div class="card card-flush py-5">
        <div class="d-flex flex-wrap flex-sm-nowrap">
          <div class="flex-grow-1">
            <div
              class="d-flex justify-content-between align-items-start flex-wrap mb-0"
            >
              <div class="card-header border-bottom-0">
                <h3 class="card-title">
                  {{ this.returnTitle() }}
                </h3>
              </div>
              <div class="d-flex py-3 px-8">
                <button
                  class="btn btn-danger svg-icon-white me-2"
                  @click="this.cancelarConfiguracao()"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Cancelar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white"
                  @click="this.confirmarConfiguracao()"
                  v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span class="svg-icon svg-icon-1" v-if="!this.loading">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Confirmar
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mEstoque'"
          class="card-body pt-5"
        >
          <a href="#" id="idmEstoque"></a>
          <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-12 col-xl-12 col-xxl-4 mb-2">
              <h4 class="text-primary ms-4">Análise de preço de venda</h4>
              <div class="card border border-rounded border-gray-300 mb-0 p-6">
                <div class="d-flex align-self-start flex-column col-auto">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rdAnalisePrecoVenda"
                      id="rdLucroSemiLiquido"
                      value="1"
                      tabindex="-1"
                      :checked="this.configuracao.estoque_tipo_lucro === '1'"
                      @change="this.configuracao.estoque_tipo_lucro = '1'"
                    />
                    <label
                      class="form-check-label pt-2"
                      for="rdLucroSemiLiquido"
                    >
                      <h6>Lucro semi líquido</h6>
                    </label>
                  </div>
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rdAnalisePrecoVenda"
                      id="rdLucroBruto"
                      value="0"
                      tabindex="-1"
                      :checked="this.configuracao.estoque_tipo_lucro === '0'"
                      @change="this.configuracao.estoque_tipo_lucro = '0'"
                    />
                    <label class="form-check-label pt-2" for="rdLucroBruto">
                      <h6>Lucro bruto</h6>
                    </label>
                  </div>
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rdAnalisePrecoVenda"
                      id="rdLucroCumulativo"
                      value="2"
                      tabindex="-1"
                      :checked="this.configuracao.estoque_tipo_lucro === '2'"
                      @change="this.configuracao.estoque_tipo_lucro = '2'"
                    />
                    <label
                      class="form-check-label pt-2"
                      for="rdLucroCumulativo"
                    >
                      <h6>Lucro cumulativo</h6>
                    </label>
                  </div>
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rdAnalisePrecoVenda"
                      id="rdLucroLiquido"
                      value="3"
                      tabindex="-1"
                      :checked="this.configuracao.estoque_tipo_lucro === '3'"
                      @change="this.configuracao.estoque_tipo_lucro = '3'"
                    />
                    <label class="form-check-label pt-2" for="rdLucroLiquido">
                      <h6>Lucro líquido</h6>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-8 col-lg-12 col-xl-12 col-xxl-8 mb-2">
              <div class="mb-10 fv-row">
                <h4 class="text-primary ms-4">Descrição dos campos</h4>
                <div class="table-responsive">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tr
                      class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
                      role="row"
                    >
                      <th>CAMPO</th>
                      <th class="ps-7">DESCRIÇÃO</th>
                    </tr>
                    <tbody>
                      <tr
                        v-for="(label, index) in this.labelDescricaoProdutos"
                        :key="label"
                      >
                        <td class="align-middle text-primary">
                          {{ this.retornaLabelDescricaoProdutos(label.campo) }}
                        </td>
                        <td class="align-middle">
                          <FocusTextInput
                            :id="`DescricaoProdutos${index}`"
                            class="min-w-200px"
                            placeholder="Descrição"
                            v-model="label.descricao"
                            @keydown.stop.prevent.enter="
                              nextFocus(`DescricaoProdutos${index + 1}`)
                            "
                          ></FocusTextInput>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoSituacaoTributaria'"
          class="card-body pt-5"
        >
          <a href="#" id="idmFaturamentoSituacaoTributaria"></a>
          <h4 class="text-primary ms-4">Cálculos Situação Tributária</h4>
          <div class="card border border-rounded border-gray-300 mb-0 p-6">
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label class="form-check-label text-dark fs-6 fw-bold">
                  ST - Descrição
                </label>
                <label class="form-check-label text-dark fs-6 fw-bold">
                  Calcula ICMS
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb00"
                >
                  00 - Tributada integralmente
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb00"
                    :checked="this.configuracao.st_00 === '1'"
                    @change="
                      this.configuracao.st_00 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb10"
                >
                  10 - Tributada e com cobrança de ICMs por Substituição
                  Tributária
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb10"
                    :checked="this.configuracao.st_10 === '1'"
                    @change="
                      this.configuracao.st_10 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb20"
                >
                  20 - Com Redução da Base de Cálculo
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb20"
                    :checked="this.configuracao.st_20 === '1'"
                    @change="
                      this.configuracao.st_20 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb30"
                >
                  30 - Isenta ou não Tributada e com cobrança de ICMs por
                  Substituição Tributária
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb30"
                    :checked="this.configuracao.st_30 === '1'"
                    @change="
                      this.configuracao.st_30 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb40"
                >
                  40 - Isenta
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb40"
                    :checked="this.configuracao.st_40 === '1'"
                    @change="
                      this.configuracao.st_40 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb41"
                >
                  41 - Não Tributada
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb41"
                    :checked="this.configuracao.st_41 === '1'"
                    @change="
                      this.configuracao.st_41 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb50"
                >
                  50 - Com Suspenção
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb50"
                    :checked="this.configuracao.st_50 === '1'"
                    @change="
                      this.configuracao.st_50 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb51"
                >
                  51 - Diferimento
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb51"
                    :checked="this.configuracao.st_51 === '1'"
                    @change="
                      this.configuracao.st_51 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark fs-6 fw-bold"
                  for="rb60"
                >
                  60 - ICMs cobrado anteriormente por Substituição Tributária
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb60"
                    :checked="this.configuracao.st_60 === '1'"
                    @change="
                      this.configuracao.st_60 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-4">
                <label
                  class="form-check-label text-dark text-dark fs-6 fw-bold"
                  for="rb70"
                >
                  70 - Com redução de base de cálculo de ICMs por Substituição
                  Tributária
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb70"
                    :checked="this.configuracao.st_70 === '1'"
                    @change="
                      this.configuracao.st_70 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 fv-row d-flex justify-content-between mb-0">
                <label
                  class="form-check-label text-dark text-dark fs-6 fw-bold"
                  for="rb90"
                >
                  90 - Outras
                </label>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rb90"
                    :checked="this.configuracao.st_90 === '1'"
                    @change="
                      this.configuracao.st_90 = $event.target.checked
                        ? '1'
                        : '0'
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mCertificadoDigital'"
          class="card-body pt-5"
        >
          <a href="#" id="idmCertificadoDigital"></a>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
              <h4 class="text-primary">Tipo do certificado</h4>
              <div class="d-flex align-self-start flex-column col-auto mt-4">
                <div class="form-check form-check-custom form-check-sm mb-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rdTipoCertificadoA1"
                    id="rdTipoCertificadoA1"
                    value="0"
                    tabindex="-1"
                    :checked="this.configuracao.tipo_certificado === '0'"
                    @change="this.configuracao.tipo_certificado = '0'"
                  />
                  <label
                    class="form-check-label pt-2"
                    for="rdTipoCertificadoA1"
                  >
                    <h6>Certificado A1</h6>
                  </label>
                </div>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rdTipoCertificadoA3"
                    id="rdTipoCertificadoA3"
                    value="1"
                    tabindex="-1"
                    :checked="this.configuracao.tipo_certificado === '1'"
                    @change="this.configuracao.tipo_certificado = '1'"
                  />
                  <label
                    class="form-check-label pt-2"
                    for="rdTipoCertificadoA3"
                  >
                    <h6>Certificado A3</h6>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
              <h4 class="text-primary">Ambiente de transmissão</h4>
              <div class="d-flex align-self-start flex-column col-auto mt-4">
                <div class="form-check form-check-custom form-check-sm mb-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rdTipoAmbienteDFeProducao"
                    id="rdTipoAmbienteDFeProducao"
                    value="0"
                    tabindex="-1"
                    :checked="this.configuracao.tipo_ambiente_dfe === '1'"
                    @change="this.configuracao.tipo_ambiente_dfe = '1'"
                  />
                  <label
                    class="form-check-label pt-2"
                    for="rdTipoAmbienteDFeProducao"
                  >
                    <h6>Produção</h6>
                  </label>
                </div>
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rdTipoAmbienteDFeHomologacao"
                    id="rdTipoAmbienteDFeHomologacao"
                    value="1"
                    tabindex="-1"
                    :checked="this.configuracao.tipo_ambiente_dfe === '2'"
                    @change="this.configuracao.tipo_ambiente_dfe = '2'"
                  />
                  <label
                    class="form-check-label pt-2"
                    for="rdTipoAmbienteDFeHomologacao"
                  >
                    <h6>Homologação</h6>
                  </label>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
              v-if="this.configuracao.tipo_certificado === '0'"
            >
              <div class="card card-flush">
                <div class="card-header">
                  <div class="card-title">
                    <h4>Arquivo do Certificado</h4>
                  </div>
                </div>
                <div class="card-body text-center pt-0">
                  <div
                    id="imgArquivoCertificado"
                    class="image-input image-input-outline"
                    data-kt-image-input="true"
                  >
                    <div
                      class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                      v-if="this.configuracao.arquivo_certificado"
                      :style="{
                        'background-image': `url(media/svg/files/doc-dark.svg)`,
                      }"
                    ></div>
                    <div
                      class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                      v-else
                      :style="{
                        'background-image': `url(media/svg/files/doc.svg)`,
                      }"
                    ></div>
                    <label
                      class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                      data-kt-image-input-action="change"
                      data-bs-toggle="tooltip"
                      data-bs-dismiss="click"
                      title="Alterar certificado"
                    >
                      <i class="bi bi-pencil-fill fs-7"></i>
                      <input
                        ref="fileInputCertificadoA1"
                        type="file"
                        name="certificadoA1"
                        accept=".pfx,.p12,.pem,.crt,.cert,.key,.jks,.pkcs12"
                        @input="pickFileCertificado"
                      />
                      <input type="hidden" name="certificadoA1_remove" />
                    </label>
                    <span
                      class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                      data-kt-image-input-action="remove"
                      data-bs-toggle="tooltip"
                      @click="removerCertificadoA1()"
                      data-bs-dismiss="click"
                      title="Remover certificado"
                    >
                      <i class="bi bi-x fs-2"></i>
                    </span>
                  </div>
                  <div
                    class="form-text mt-6"
                    v-if="
                      this.configuracao.arquivo_certificado === undefined ||
                      this.configuracao.arquivo_certificado === null ||
                      this.configuracao.arquivo_certificado.length <= 0
                    "
                  >
                    <span class="badge badge-danger"
                      >Nenhum certificado selecionado</span
                    >
                  </div>
                  <div class="form-text mt-6">
                    Selecione um certificado. Apenas *.pfx, *.p12, *.pem, *.crt,
                    *.cert, *.key, *.jks, *.pkcs12 aquivo de certificado é
                    aceito
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
              v-if="this.configuracao.tipo_certificado === '0'"
            >
              <div class="mb-10 fv-row">
                <label for="txtSenhaCertificado" class="form-label"
                  >Senha do certificado</label
                >
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="bi bi-lock-fill fs-3"></i>
                  </span>
                  <input
                    :type="
                      this.exibirSenhaCertificado === false
                        ? 'password'
                        : 'text'
                    "
                    id="txtSenhaCertificado"
                    class="form-control"
                    v-model="configuracao.senha_certificado"
                  />
                  <button
                    class="input-group-text"
                    @click="
                      this.exibirSenhaCertificado = !this.exibirSenhaCertificado
                    "
                  >
                    <i class="bi bi-eye-fill fs-3"></i>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["senha_certificado"] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoObservacoes'"
          class="card-body pt-5"
        >
          <a href="#" id="idmFaturamentoObservacoes"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div class="mb-5 fv-row">
                <label class="form-label">Observação padrão faturamento</label>
                <textarea
                  id="txtObservacaoPadraoFaturamento"
                  class="form-control mb-2"
                  maxlength="5000"
                  style="height: 150px"
                  v-model="this.configuracao.obs_padrao_faturamento"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["obs_padrao_faturamento"] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-5 fv-row">
                <label class="form-label"
                  >Percentual para o cálculo do crédito de ICMS</label
                >
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% Crédito ICMS"
                  style="text-align: right"
                  v-model="this.configuracao.percentual_simples_nacional"
                  :options="options"
                ></CurrencyInput>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div class="fv-row">
                <div
                  class="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10"
                >
                  <span class="svg-icon svg-icon-2tx svg-icon-primary me-4">
                    <inline-svg src="media/icons/duotune/general/gen044.svg" />
                  </span>
                  <div class="d-flex flex-column pe-0 pe-sm-10 mb-2">
                    <h4 class="fw-semibold">
                      Para observações com aproveitamento de crédito, siga o
                      exemplo abaixo
                    </h4>
                    <span
                      >PERMITE O APROVEITAMENTO DO CRÉDITO DE ICMS NO VALOR DE
                      R$...; CORRESPONDENTE À ALÍQUOTA DE ...%, NOS TERMOS DO
                      ARTIGO 23 DA LC 123</span
                    >
                  </div>
                  <div class="row">
                    <button
                      @click="this.utilizarObservacaoCredito()"
                      type="button"
                      class="btn btn-sm btn-primary"
                    >
                      <span class="svg-icon svg-icon-2">
                        <inline-svg
                          src="media/icons/duotune/communication/com009.svg"
                        />
                      </span>
                      Utilizar observação
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoBaseICMS'"
          class="card-body pt-5"
        >
          <a href="#" id="idmFaturamentoBaseICMS"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
            >
              <div class="form-check form-check-custom form-check">
                <label class="form-check-label text-dark fs-6 fw-bold ms-0 p-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="rbFaturamentoUtilizarFormulaBcICMS"
                    :checked="
                      this.configuracao.utilizar_formula_bc_icms === '1'
                    "
                    @change="
                      this.configuracao.utilizar_formula_bc_icms = $event.target
                        .checked
                        ? '1'
                        : '0'
                    "
                  />
                  Utilizar formula para calcular a Base do ICMS e Valor do ICMS
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Fórmula Base de Cálculo ICMS</label>
                <textarea
                  id="txtFormulaBcIcms"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_basecalculo_icms"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_basecalculo_icms"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Fórmula Valor do ICMS</label>
                <textarea
                  id="txtFormulaValorIcms"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_valor_icms"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_valor_icms"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaValorICMS($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoIcmsSubstituicao'"
          class="card-body pt-5"
        >
          <a href="#" id="idmFaturamentoIcmsSubstituicao"></a>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label"
                  >Fórmula Base de Cálculo ICMs Substituição</label
                >
                <textarea
                  id="txtFormulaBcIcmsST"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_basecalculo"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_basecalculo"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoBaseICMS($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label"
                  >Fórmula Valor do ICMS Substituição</label
                >
                <textarea
                  id="txtFormulaValorIcmsST"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_icms_sub"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_icms_sub"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoValorICMS($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoIPI'"
          class="card-body pt-5"
        >
          <a href="#" id="idmFaturamentoIPI"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
            >
              <div class="form-check form-check-custom form-check">
                <label class="form-check-label text-dark fs-6 fw-bold ms-0 p-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="rbFaturamentoUtilizarFormulaIPI"
                    :checked="this.configuracao.utilizar_formula_bc_ipi === '1'"
                    @change="
                      this.configuracao.utilizar_formula_bc_ipi = $event.target
                        .checked
                        ? '1'
                        : '0'
                    "
                  />
                  Utilizar formula para calcular a Base do IPI
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Fórmula Base de Cálculo IPI</label>
                <textarea
                  id="txtFormulaBcIPI"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_base_ipi"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_base_ipi"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseIPI($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoPISCOFINS'"
          class="card-body pt-5"
        >
          <a href="#" id="mFaturamentoPISCOFINS"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
            >
              <div class="form-check form-check-custom form-check">
                <label class="form-check-label text-dark fs-6 fw-bold ms-0 p-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="rbFaturamentoUtilizarFormulaPISCOFINS"
                    :checked="
                      this.configuracao.utilizar_formula_bc_pis_cofins === '1'
                    "
                    @change="
                      this.configuracao.utilizar_formula_bc_pis_cofins = $event
                        .target.checked
                        ? '1'
                        : '0'
                    "
                  />
                  Utilizar formula para calcular a Base do PIS/COFINS
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Fórmula Base de PIS</label>
                <textarea
                  id="txtFormulaBcPIS"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_base_pis"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_base_pis"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBasePIS($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Fórmula Base COFINS</label>
                <textarea
                  id="txtFormulaBcCofins"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 150px"
                  v-model="this.configuracao.formula_base_cofins"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["formula_base_cofins"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Campos</label>
                <div class="table-responsive mh-150px">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tbody>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          BASE_CALCULO_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_ICMS_SUBSTITUICAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_BASE_CALCULO_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          ALIQ_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_ICMS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_TOTAL_PRODUTOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_TOTAL_NOTA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          MVA
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_UNITARIO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          QTD
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          DESCONTO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          ACRESCIMO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_TOTAL_ITEM
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          ALIQI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_REDUCAO
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseCOFINS($event)"
                        >
                          VALOR_IPI
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_FRETE
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="align-middle"
                          @dblclick="this.campoFormulaBaseICMS($event)"
                        >
                          VALOR_OUTRAS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mFaturamentoModelos'"
          class="card-body pt-5"
        >
          <a href="#" id="idmFaturamentoModelos"></a>
          <div class="card card-flush py-4">
            <div class="row">
              <div
                class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
              >
                <div class="form-check form-check-custom form-check">
                  <label class="form-check-label text-dark fs-6 fw-bold">
                    <input
                      class="form-check-input me-2"
                      type="checkbox"
                      id="rbFaturamentoExibirSelecaoModelo"
                      :checked="
                        this.configuracao.faturamento_exibir_selecao_modelo ===
                        '1'
                      "
                      @change="
                        this.configuracao.faturamento_exibir_selecao_modelo =
                          $event.target.checked ? '1' : '0'
                      "
                    />
                    Exibir tela para selecionar modelo ao incluir um novo
                    faturamento
                  </label>
                </div>
              </div>
            </div>
            <div class="card-header">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder fs-3 mb-1">Modelos</span>
              </h3>
              <div class="card-toolbar">
                <div
                  class="d-flex justify-content-end"
                  data-kt-customer-table-toolbar="base"
                >
                  <button
                    @click="adicionarConfiguracoesModelosFaturamento()"
                    type="button"
                    class="btn btn-sm btn-light btn-primary"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr075.svg" /></span
                    >Adicionar
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body pt-0 pb-0">
              <Datatable
                ref="tableModelosFaturamento"
                :table-header="tableHeaderModelosFaturamento"
                :table-data="tableDataModelosFaturamento"
                :table-pagination="tablePaginationModelosFaturamento"
                :page-sizes="pageSizesModelosFaturamento"
                :enable-items-per-page-dropdown="true"
                :hide-on-single-page="false"
                empty-table-text="Nenhum registro encontrado"
                :colors="true"
              >
                <template v-slot:cell-id="{ row: modelo }">
                  {{ modelo.id }}
                </template>
                <template v-slot:cell-modelo="{ row: modelo }">
                  {{ modelo.modelo }}
                </template>
                <template v-slot:cell-serie="{ row: modelo }">
                  {{ modelo.serie }}
                </template>
                <template v-slot:cell-ultima_nota="{ row: modelo }">
                  {{ modelo.ultima_nota }}
                </template>
                <template v-slot:cell-descricao="{ row: modelo }">
                  <div class="min-w-200px">{{ modelo.descricao }}</div>
                </template>
                <template v-slot:cell-padrao="{ row: modelo }">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid"
                  >
                    <input
                      readonly
                      class="form-check-input"
                      type="checkbox"
                      disabled
                      :checked="modelo.padrao === '1'"
                    />
                  </div>
                </template>
                <template v-slot:cell-nfe="{ row: modelo }">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid"
                  >
                    <input
                      disabled
                      readonly
                      class="form-check-input"
                      type="checkbox"
                      :checked="modelo.nfe === '1'"
                    />
                  </div>
                </template>
                <template v-slot:cell-calcular_impostos="{ row: modelo }">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid"
                  >
                    <input
                      disabled
                      readonly
                      class="form-check-input"
                      type="checkbox"
                      :checked="modelo.calcular_impostos === '1'"
                    />
                  </div>
                </template>
                <template v-slot:cell-gerar_comissao="{ row: modelo }">
                  <div
                    class="form-check form-check-sm form-check-custom form-check-solid"
                  >
                    <input
                      disabled
                      readonly
                      class="form-check-input"
                      type="checkbox"
                      :checked="modelo.gerar_comissao === '1'"
                    />
                  </div>
                </template>
                <template v-slot:cell-acoes="{ row: modelo }">
                  <div>
                    <button
                      class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                      @click="editarConfiguracoesModelosFaturamento(modelo)"
                    >
                      <span class="svg-icon svg-icon-5 m-0">
                        <inline-svg src="media/icons/duotune/art/art005.svg" />
                      </span>
                    </button>
                    <button
                      class="btn btn-icon btn-bg-light btn-active-danger btn-sm"
                      @click="removerConfiguracoesModelosFaturamento(modelo)"
                    >
                      <span class="svg-icon svg-icon-5 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen027.svg"
                        />
                      </span>
                    </button>
                  </div>
                </template>
              </Datatable>
            </div>
          </div>
        </div>
        <div v-if="this.idMenuSelecionado === 'mNFe'" class="card-body pt-5">
          <a href="#" id="idmNFe"></a>
          <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-12 col-xl-12 col-xxl-12 mb-2">
              <div class="form-check form-check-custom form-check mb-2">
                <label class="form-check-label text-dark fs-6 fw-bold ms-0 p-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="rbNFeUtilizarBarrasLugarCodigo"
                    :checked="
                      this.configuracao.utilizar_barras_no_codigo_nfe === '1'
                    "
                    @change="
                      this.configuracao.utilizar_barras_no_codigo_nfe = $event
                        .target.checked
                        ? '1'
                        : '0'
                    "
                  />
                  Utilizar código de barras no lugar do código (campo cProd)
                </label>
              </div>
              <div class="form-check form-check-custom form-check mb-2">
                <label class="form-check-label text-dark fs-6 fw-bold ms-0 p-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="rbNFeUtilizarCaracteristicaLugarCodigo"
                    :checked="
                      this.configuracao
                        .utilizar_caracteristica_no_codigo_nfe === '1'
                    "
                    @change="
                      this.configuracao.utilizar_caracteristica_no_codigo_nfe =
                        $event.target.checked ? '1' : '0'
                    "
                  />
                  Utilizar caracteristica no lugar do código (campo cProd)
                </label>
              </div>
              <div class="form-check form-check-custom form-check mt-8 mb-2">
                <label class="form-check-label text-dark fs-6 fw-bold ms-0 p-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    id="rbNFeUtilizarTextoMarcaDagua"
                    :checked="
                      this.configuracao.utilizar_texto_marca_dagua_nfe === '1'
                    "
                    @change="
                      this.configuracao.utilizar_texto_marca_dagua_nfe = $event
                        .target.checked
                        ? '1'
                        : '0'
                    "
                  />
                  Exibir marca d'agua na impressão da NF-e
                </label>
              </div>
              <div
                class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
              >
                <div class="mb-4 fv-row">
                  <label for="txtTituloMarcaDagua" class="form-label"
                    >Título da marca d'agua</label
                  >
                  <input
                    type="text"
                    id="txtTituloMarcaDagua"
                    class="form-control"
                    v-model="this.configuracao.titulo_marca_dagua_nfe"
                    maxlength="255"
                  />
                  <div class="fv-plugins-message-container invalid-feedback">
                    {{ errosValidacao["titulo_marca_dagua_nfe"] }}
                  </div>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
              >
                <div class="mb-4 fv-row">
                  <label for="txtTextoMarcaDagua" class="form-label"
                    >Texto da marca d'agua</label
                  >
                  <input
                    type="text"
                    id="txtTextoMarcaDagua"
                    class="form-control"
                    v-model="this.configuracao.texto_marca_dagua_nfe"
                    maxlength="255"
                  />
                  <div class="fv-plugins-message-container invalid-feedback">
                    {{ errosValidacao["texto_marca_dagua_nfe"] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mPedidoVendaConfiguracoes'"
          class="card-body pt-5"
        >
          <a href="#" id="idmPedidoVendaConfiguracoes"></a>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div class="mb-10 fv-row">
                <label class="form-label">Descrição dos campos</label>
                <div class="table-responsive">
                  <table
                    class="table table-hover table-rounded table-striped border gy-1 gs-7"
                  >
                    <tr
                      class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
                      role="row"
                    >
                      <th>CAMPO</th>
                      <th class="ps-7">DESCRIÇÃO</th>
                    </tr>
                    <tbody>
                      <tr
                        v-for="(label, index) in this.labelDescricaoPedidos"
                        :key="label"
                      >
                        <td class="align-middle text-primary">
                          {{ this.retornaLabelDescricaoPedidos(label.campo) }}
                        </td>
                        <td class="align-middle">
                          <FocusTextInput
                            :id="`DescricaoPedidos${index}`"
                            class="min-w-200px"
                            placeholder="Descrição"
                            v-model="label.descricao"
                            @keydown.stop.prevent.enter="
                              nextFocus(`DescricaoPedidos${index + 1}`)
                            "
                          ></FocusTextInput>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.idMenuSelecionado === 'mGenerator'"
          class="card-body pt-5"
        >
          <a href="#" id="idmGenerator"></a>
          <div class="row">
            <div
              class="d-flex flex-row col-sm-12 col-md-6 col-lg-12 col-xl-12 col-xxl-6"
            >
              <div class="col-12 mw-200px fv-row mb-6">
                <label class="form-label">Último Código Produto</label>
                <el-input-number
                  id="ultimo_codigo_produto"
                  v-model="this.generator.ultimo_codigo_produto"
                  :min="0"
                  :max="999999999"
                  size="large"
                  controls-position="right"
                  :disabled="this.edicaoTabelaGenerator != 'Produto'"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["ultimo_codigo_produto"] }}
                </div>
              </div>
              <div class="d-flex align-items-center col-auto fv-row mb-6 mt-6">
                <button
                  v-if="this.edicaoTabelaGenerator != 'Produto'"
                  class="btn btn-icon btn-bg-light btn-active-primary me-2"
                  @click="
                    (this.edicaoTabelaGenerator = 'Produto'),
                      this.nextFocus('ultimo_codigo_produto')
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/art/art005.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Produto'"
                  class="btn btn-icon btn-bg-light btn-active-success me-2"
                  @click="
                    this.confirmarGenerator(
                      this.edicaoTabelaGenerator,
                      this.generator.ultimo_codigo_produto
                    )
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr016.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Produto'"
                  class="btn btn-icon btn-bg-light btn-active-danger"
                  @click="this.edicaoTabelaGenerator = ''"
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr015.svg" />
                  </span>
                </button>
              </div>
            </div>
            <div
              class="d-flex flex-row col-sm-12 col-md-6 col-lg-12 col-xl-12 col-xxl-6"
            >
              <div class="col-12 mw-200px fv-row mb-6">
                <label class="form-label">Último Código Cliente</label>
                <el-input-number
                  id="ultimo_codigo_cliente"
                  v-model="this.generator.ultimo_codigo_cliente"
                  :min="0"
                  :max="999999999"
                  size="large"
                  controls-position="right"
                  :disabled="this.edicaoTabelaGenerator != 'Cliente'"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["ultimo_codigo_cliente"] }}
                </div>
              </div>
              <div class="d-flex align-items-center col-auto fv-row mb-6 mt-6">
                <button
                  v-if="this.edicaoTabelaGenerator != 'Cliente'"
                  class="btn btn-icon btn-bg-light btn-active-primary me-2"
                  @click="
                    (this.edicaoTabelaGenerator = 'Cliente'),
                      this.nextFocus('ultimo_codigo_cliente')
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/art/art005.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Cliente'"
                  class="btn btn-icon btn-bg-light btn-active-success me-2"
                  @click="
                    this.confirmarGenerator(
                      this.edicaoTabelaGenerator,
                      this.generator.ultimo_codigo_cliente
                    )
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr016.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Cliente'"
                  class="btn btn-icon btn-bg-light btn-active-danger"
                  @click="this.edicaoTabelaGenerator = ''"
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr015.svg" />
                  </span>
                </button>
              </div>
            </div>
            <div
              class="d-flex flex-row col-sm-12 col-md-6 col-lg-12 col-xl-12 col-xxl-6"
            >
              <div class="col-12 mw-200px fv-row mb-6">
                <label class="form-label">Último Código Fornecedor</label>
                <el-input-number
                  id="ultimo_codigo_fornecedor"
                  v-model="this.generator.ultimo_codigo_fornecedor"
                  :min="0"
                  :max="999999999"
                  size="large"
                  controls-position="right"
                  :disabled="this.edicaoTabelaGenerator != 'Fornecedor'"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["ultimo_codigo_fornecedor"] }}
                </div>
              </div>
              <div class="d-flex align-items-center col-auto fv-row mb-6 mt-6">
                <button
                  v-if="this.edicaoTabelaGenerator != 'Fornecedor'"
                  class="btn btn-icon btn-bg-light btn-active-primary me-2"
                  @click="
                    (this.edicaoTabelaGenerator = 'Fornecedor'),
                      this.nextFocus('ultimo_codigo_fornecedor')
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/art/art005.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Fornecedor'"
                  class="btn btn-icon btn-bg-light btn-active-success me-2"
                  @click="
                    this.confirmarGenerator(
                      this.edicaoTabelaGenerator,
                      this.generator.ultimo_codigo_fornecedor
                    )
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr016.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Fornecedor'"
                  class="btn btn-icon btn-bg-light btn-active-danger"
                  @click="this.edicaoTabelaGenerator = ''"
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr015.svg" />
                  </span>
                </button>
              </div>
            </div>
            <div
              class="d-flex flex-row col-sm-12 col-md-6 col-lg-12 col-xl-12 col-xxl-6"
            >
              <div class="col-12 mw-200px fv-row mb-6">
                <label class="form-label">Último Código Grupo</label>
                <el-input-number
                  id="ultimo_codigo_grupo"
                  v-model="this.generator.ultimo_codigo_grupo"
                  :min="0"
                  :max="999999999"
                  size="large"
                  controls-position="right"
                  :disabled="this.edicaoTabelaGenerator != 'Grupo'"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["ultimo_codigo_grupo"] }}
                </div>
              </div>
              <div class="d-flex align-items-center col-auto fv-row mb-6 mt-6">
                <button
                  v-if="this.edicaoTabelaGenerator != 'Grupo'"
                  class="btn btn-icon btn-bg-light btn-active-primary me-2"
                  @click="
                    (this.edicaoTabelaGenerator = 'Grupo'),
                      this.nextFocus('ultimo_codigo_grupo')
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/art/art005.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Grupo'"
                  class="btn btn-icon btn-bg-light btn-active-success me-2"
                  @click="
                    this.confirmarGenerator(
                      this.edicaoTabelaGenerator,
                      this.generator.ultimo_codigo_grupo
                    )
                  "
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr016.svg" />
                  </span>
                </button>
                <button
                  v-if="this.edicaoTabelaGenerator === 'Grupo'"
                  class="btn btn-icon btn-bg-light btn-active-danger"
                  @click="this.edicaoTabelaGenerator = ''"
                >
                  <span class="svg-icon svg-icon-2 m-0">
                    <inline-svg src="media/icons/duotune/arrows/arr015.svg" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EditarModelosFaturamentoModal
    v-if="exibirModalEditarModelosFaturamento"
    :id="idModeloFaturamento"
    @exibirModalEditarModelosFaturamento="modalEditarModelosFaturamento"
    @confirmarModalEditarModelosFaturamento="
      confirmarModalEditarModelosFaturamento
    "
  ></EditarModelosFaturamentoModal>
  <LoadingModal
    :nomeRef="'loadingModalConfiguracoes'"
    mensagem=""
    v-if="this.loadingConfiguracao === true"
  ></LoadingModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
import FocusTextInput from "@/components/text/FocusTextInput";
import EditarModelosFaturamentoModal from "@/views/configuracoes/EditarModelosFaturamentoModal.vue";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import CurrencyInput from "@/components/text/CurrencyInput";
import { mapState } from "vuex";

const toast = useToast();

export default {
  components: {
    FocusTextInput,
    EditarModelosFaturamentoModal,
    Datatable,
    CurrencyInput,
    LoadingModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async confirmarConfiguracao() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.loading = true;
      this.confirmouCadastro = true;

      try {
        var formData = this.$utils.convertModelToFormData(this.configuracao);
        var retPut = await this.$store.dispatch(
          "configuracao/putConfiguracao",
          formData
        );
        if (retPut.Success === true) {
          await this.confirmarLabelDescricaoProdutos();
          await this.confirmarLabelDescricaoPedidos();
        }
      } catch (error) {
        this.errosValidacaoGeral.push(
          ...this.$utils.retornarValoresJson(error)
        );
        this.errosGerais = error;
        this.errosValidacao = error;
        this.confirmouCadastro = false;
      }

      this.loading = false;

      if (this.confirmouCadastro === true) {
        toast.success("Configuração atualizada com sucesso!", {
          timeout: 3000,
        });
        this.$router.push("/dashboard");
      } else {
        toast.error("Ocorreu uma falha ao gravar a configuração, verifique!", {
          timeout: 5000,
        });
      }
    },
    async confirmarLabelDescricaoProdutos() {
      for (var i = 0; i < this.labelDescricaoProdutos.length; i++) {
        try {
          var retPut = await this.$store.dispatch(
            "labelDescricao/putLabelDescricao",
            this.labelDescricaoProdutos[i]
          );
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      }
    },
    async confirmarLabelDescricaoPedidos() {
      for (var i = 0; i < this.labelDescricaoPedidos.length; i++) {
        try {
          var retPut = await this.$store.dispatch(
            "labelDescricao/putLabelDescricao",
            this.labelDescricaoPedidos[i]
          );
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      }
    },
    async confirmarGenerator(tabela, ultimo_codigo) {
      await this.exibirModalLoading(true);
      try {
        var ret = await this.$store.dispatch(
          "generator/updateGeneratorTabela",
          "?&tabela=" + tabela + "&ultimo_codigo=" + ultimo_codigo
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.$swal.showSuccessAlert(ret.Message, (alert) => {
            this.edicaoTabelaGenerator = "";
          });
        } else {
          await this.exibirModalLoading(false);
          await this.$swal.showErrorAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        if (error.Message) {
          await this.$swal.showErrorAlert(error.Message);
        }
      }
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loadingConfiguracao = true;
        getOrCreateInstanceModal(
          "loadingModalConfiguracoes",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalConfiguracoes", () => {
          this.loadingConfiguracao = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    cancelarConfiguracao() {
      this.$router.push("/dashboard");
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        setTimeout(() => {
          document.getElementById(id).focus();
        }, 100);
      }
    },
    campoBaseICMS(e) {
      var doc = document.getElementById("txtFormulaBcIcmsST");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_basecalculo =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    campoValorICMS(e) {
      var doc = document.getElementById("txtFormulaValorIcmsST");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_icms_sub =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    campoFormulaBaseICMS(e) {
      var doc = document.getElementById("txtFormulaBcIcms");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_basecalculo_icms =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    campoFormulaValorICMS(e) {
      var doc = document.getElementById("txtFormulaValorIcms");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_valor_icms =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    campoFormulaBasePIS(e) {
      var doc = document.getElementById("txtFormulaBcPIS");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_base_pis =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    campoFormulaBaseCOFINS(e) {
      var doc = document.getElementById("txtFormulaBcCofins");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_base_cofins =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    campoFormulaBaseIPI(e) {
      var doc = document.getElementById("txtFormulaBcIPI");
      doc.focus();
      var text = doc.value;
      this.configuracao.formula_base_ipi =
        text.substring(0, doc.selectionStart) +
        e.target.innerText +
        text.substring(doc.selectionEnd, text.length);
    },
    menuClick(id) {
      this.idMenuSelecionado = id;
      setTimeout(() => {
        this.nextFocus("id" + this.idMenuSelecionado);
      }, 100);
      var doc = document.getElementById(this.idMenuSelecionado);
      if (
        doc.parentElement.parentElement.classList.contains(
          "menu-sub-accordion"
        ) === false
      ) {
        var docs = document
          .getElementById("menuConfiguracoes")
          .getElementsByClassName("menu-accordion");
        if (docs != null) {
          for (var i = 0; i < docs.length; i++) {
            docs[i].classList.remove("show");
            docs[i].classList.remove("hover");
            docs[i]
              .getElementsByClassName("menu-sub-accordion")[0]
              .classList.remove("show");
          }
        }
      }
    },
    returnTitle() {
      var doc = document.getElementById(this.idMenuSelecionado);
      if (doc !== null) {
        return doc.getElementsByClassName("menu-title")[0].innerText;
      } else {
        return "";
      }
    },
    async carregarConfiguracoes() {
      this.loading = true;
      try {
        var ret = await this.$store.dispatch(
          "configuracao/getConfiguracaoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.configuracao = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.idMenuSelecionado = "mPrincipal";
    },
    retornaLabelDescricaoProdutos(campo) {
      if (campo === "b05eb8ed-b413-4a7f-8bba-efdbf3182d6c") {
        return "Label Preco de Venda";
      } else if (campo === "5a453ca4-9f76-44c3-b603-11ea1ab3e4fd") {
        return "Label Preco de Revenda";
      } else if (campo === "f03cc6d6-99dd-4d15-abc9-f803fc39b26f") {
        return "Label Preco Distribuidora";
      } else if (campo === "53a025c0-9c12-4843-85dd-2c32af180720") {
        return "Label Venda à Prazo";
      } else if (campo === "808c0401-b5f5-4fe6-9ab5-69e76cfc842b") {
        return "Label Prazo Revenda";
      } else if (campo === "09acccc0-eb6e-49b2-9990-61274f5fb22e") {
        return "Label Ultima Compra";
      } else if (campo === "59f5abd9-0622-41ef-b6d5-ab47b9a10a60") {
        return "Label Custo Médio";
      } else if (campo === "3e21b497-8ee5-497b-b268-0194a4562473") {
        return "Label Prazo Distribuidora";
      } else if (campo === "06ac70d2-a02d-416c-b031-f9ca73d51e7c") {
        return "Label Outro Preco Venda";
      }
    },
    retornaLabelDescricaoPedidos(campo) {
      if (campo === "79a00056-12d0-4c8f-b3f4-d95d183ff7f6") {
        return "Label Pesagem";
      } else if (campo === "685ed62c-38c5-4fb3-a1aa-bf63265d324d") {
        return "Label Tolerância";
      } else if (campo === "056ce5f8-b997-4a72-85c9-f8162c6139da") {
        return "Label Tipo Embalagem";
      } else if (campo === "b5be0812-fe1b-465d-8757-d7599ad55464") {
        return "Label Código de Barras";
      } else if (campo === "0b1beec4-f93b-4150-b2ba-5eaa93e51159") {
        return "Label Metragem";
      }
    },
    async carregarLabelDescricaoProdutos() {
      try {
        var ret = await this.$store.dispatch(
          "labelDescricao/getLabelDescricaoOData",
          "?$filter=modulo eq 'Produtos'"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.labelDescricaoProdutos = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarLabelDescricaoPedidos() {
      try {
        var ret = await this.$store.dispatch(
          "labelDescricao/getLabelDescricaoOData",
          "?$filter=modulo eq 'Pedidos'"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.labelDescricaoPedidos = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async carregarGenerators() {
      try {
        var ret = await this.$store.dispatch("generator/getGeneratorOData", "");
        if (ret.value !== null && ret.value.length > 0) {
          this.generator = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
    },

    modalEditarModelosFaturamento(exibir) {
      this.exibirModalEditarModelosFaturamento = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_configuracoes_editar_modelos_faturamento",
          /*open*/ () => {
            this.$utils.requestFocus("txtDescricao");
          },
          /*close*/ () => {
            this.modalEditarModelosFaturamento(false);
          }
        );
      }
    },
    adicionarConfiguracoesModelosFaturamento() {
      this.idModeloFaturamento = -1;
      this.modalEditarModelosFaturamento(true);
    },
    editarConfiguracoesModelosFaturamento(modelo) {
      this.idModeloFaturamento = modelo.id;
      this.modalEditarModelosFaturamento(true);
    },
    async removerConfiguracoesModelosFaturamento(modelo) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            try {
              this.$refs.tableModelosFaturamento.setLoading(true);

              var ret = await this.$store.dispatch(
                "modelosFaturamento/deleteModelosFaturamento",
                modelo.id
              );

              if (ret.Success == true) {
                toast.success("Registro removido com sucesso!", {
                  timeout: 2000,
                });
                this.$refs.tableModelosFaturamento.load();
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      );
    },
    async confirmarModalEditarModelosFaturamento() {
      this.$refs.tableModelosFaturamento.setLoading(true);
      this.$refs.tableModelosFaturamento.load();
    },
    loadData() {
      this.tableDataModelosFaturamento.search = "";
      this.tablePaginationModelosFaturamento.page = 1;
      this.tablePaginationModelosFaturamento.rowsPerPage = 5;
      this.$refs.tableModelosFaturamento.setRowsPage(5);
      this.tableDataModelosFaturamento.filterOData = "";
      this.$refs.tableModelosFaturamento.load();
    },
    pickFileCertificado() {
      let input = this.$refs.fileInputCertificadoA1;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (
            this.configuracao.arquivo_certificado &&
            this.configuracao.arquivo_certificado !== null
          ) {
            this.configuracao.certificadoRemover =
              this.configuracao.arquivo_certificado.replace(
                this.$utils.getUrl(),
                ""
              );
          }
          this.configuracao.arquivo_certificado = e.target.result;
          this.configuracao.formFileCertificadoA1 = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    removerCertificadoA1() {
      if (
        this.configuracao.arquivo_certificado !== undefined &&
        this.configuracao.arquivo_certificado !== null &&
        this.configuracao.arquivo_certificado.length > 0
      ) {
        this.configuracao.certificadoA1Remover =
          this.configuracao.arquivo_certificado.replace(
            this.$utils.getUrl(),
            ""
          );
      } else {
        this.configuracao.certificadoA1Remover = "";
      }

      this.configuracao.arquivo_certificado = "";
      this.configuracao.formFileCertificadoA1 = null;
      this.$refs.fileInputCertificadoA1.value = null;
    },
    async utilizarObservacaoCredito() {
      this.configuracao.obs_padrao_faturamento =
        "PERMITE O APROVEITAMENTO DO CRÉDITO DE ICMS NO VALOR DE R$...; CORRESPONDENTE À ALÍQUOTA DE ...%, NOS TERMOS DO ARTIGO 23 DA LC 123";
    },
  },
  async mounted() {
    await this.carregarConfiguracoes();
    await this.carregarLabelDescricaoProdutos();
    await this.carregarLabelDescricaoPedidos();
    await this.carregarGenerators();
  },
  data() {
    return {
      edicaoTabelaGenerator: "",
      timeOut: null,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      loading: false,
      loadingConfiguracao: false,
      labelDescricaoProdutos: [],
      labelDescricaoPedidos: [],
      generator: {
        id: 0,
        ultimo_codigo_produto: 0,
        ultimo_codigo_cliente: 0,
        ultimo_codigo_fornecedor: 0,
        ultimo_codigo_grupo: 0,
      },
      exibirSenhaCertificado: false,
      configuracao: {
        id: 0,
        formula_basecalculo: "",
        formula_icms_sub: "",
        st_00: "0",
        st_10: "0",
        st_20: "0",
        st_30: "0",
        st_40: "0",
        st_41: "0",
        st_50: "0",
        st_51: "0",
        st_60: "0",
        st_70: "0",
        st_90: "0",
        estoque_tipo_lucro: "0",
        faturamento_exibir_selecao_modelo: "0",
      },
      idMenuSelecionado: "",
      loadingModelosFaturamento: false,
      exibirModalEditarModelosFaturamento: false,
      idModeloFaturamento: -1,
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      tableHeaderModelosFaturamento: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Modelo",
          key: "modelo",
          sortable: true,
        },
        {
          name: "Série",
          key: "serie",
          sortable: true,
        },
        {
          name: "Última Nota",
          key: "ultima_nota",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Padrão",
          key: "padrao",
          sortable: true,
        },
        {
          name: "NF-e",
          key: "nfe",
          sortable: true,
        },
        {
          name: "Impostos",
          key: "calcular_impostos",
          sortable: true,
        },
        {
          name: "Comissão",
          key: "gerar_comissao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableDataModelosFaturamento: {
        store: "modelosFaturamento/getModelosFaturamentoOData",
        selectOData:
          "?$select=id,modelo,serie,cfop_interna,cfop_externa,ultima_nota,nfe,padrao,descricao,calcular_impostos,gerar_comissao",
        filterOData: "",
        search: "",
      },
      tablePaginationModelosFaturamento: {
        page: 1,
        rowsPerPage: 5,
      },
      pageSizesModelosFaturamento: [
        "5",
        "10",
        "15",
        "20",
        "30",
        "50",
        "100",
        "Todos",
      ],
    };
  },
};
</script>

<style></style>
